import { render, staticRenderFns } from "./purchaseOrders.vue?vue&type=template&id=6552d2a0&"
import script from "./purchaseOrders.vue?vue&type=script&lang=js&"
export * from "./purchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./purchaseOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports